import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AgentSidebar from '../../components/registraction/AgentSidebar';
import AgentStep1Info from '../../components/registraction/AgentStep1Info';
import AgentStep2Contact from '../../components/registraction/AgentStep2Contact';
import AgentStep3Services from '../../components/registraction/AgentStep3Services';
import AgentStep4Agreement from '../../components/registraction/AgentStep4Agreement';
import AgentStep5Review from '../../components/registraction/AgentStep5Review';
import MobileStepper from '../../components/registraction/MobileStepper';
import { signup, clearSignupError } from '../../ducks/auth.duck';
import css from './FactoryRegistraction.module.css';

const AgentRegistration = ({ className, rootClassName }) => {
  const classes = classNames(rootClassName || css.root, className);
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch();
  const history = useHistory();
  const { signupInProgress, signupError } = useSelector(state => state.auth);

  const nextStep = values => {
    if (values) setFormData(prev => ({ ...prev, ...values }));
    setCurrentStep(prev => prev + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const prevStep = () => {
    dispatch(clearSignupError());
    setCurrentStep(prev => prev - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goToStep = step => {
    dispatch(clearSignupError());
    setCurrentStep(step);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSubmit = values => {
    const allData = { ...formData, ...values };
    const nameParts = (allData.contactPersonName || '').trim().split(' ');
    const firstName = nameParts[0] || 'Agent';
    const lastName = nameParts.slice(1).join(' ') || 'User';

    dispatch(
      signup({
        email: allData.email,
        password: allData.password,
        firstName,
        lastName,
        publicData: {
          userType: 'agent',
          approvalStatus: 'pending',
          companyName: allData.companyName,
          registrationNumber: allData.registrationNumber,
          country: allData.country,
          city: allData.city,
          companyDescription: allData.companyDescription,
          contactPersonName: allData.contactPersonName,
          phone: allData.phone,
          languages: allData.languages || [],
          industriesServed: allData.industriesServed || [],
          yearsOfExperience: allData.yearsOfExperience,
          warehouseAvailability: !!allData.warehouseAvailability,
          customsAssistance: !!allData.customsAssistance,
          sampleHandling: !!allData.sampleHandling,
          doorToDoorService: !!allData.doorToDoorService,
        },
      })
    )
      .then(() => history.push('/'))
      .catch(() => {});
  };

  return (
    <div className={css.main}>
      <AgentSidebar currentStep={currentStep} />
      <div className={css.content}>
        <MobileStepper currentStep={currentStep} totalSteps={5} />

        {currentStep === 1 && (
          <AgentStep1Info nextStep={nextStep} initialValues={formData} />
        )}
        {currentStep === 2 && (
          <AgentStep2Contact nextStep={nextStep} prevStep={prevStep} initialValues={formData} />
        )}
        {currentStep === 3 && (
          <AgentStep3Services nextStep={nextStep} prevStep={prevStep} initialValues={formData} />
        )}
        {currentStep === 4 && (
          <AgentStep4Agreement nextStep={nextStep} prevStep={prevStep} initialValues={formData} />
        )}
        {currentStep === 5 && (
          <AgentStep5Review
            prevStep={prevStep}
            goToStep={goToStep}
            formData={formData}
            onSubmit={handleSubmit}
            submitInProgress={signupInProgress}
            submitError={signupError}
          />
        )}
      </div>
    </div>
  );
};

AgentRegistration.defaultProps = { className: null, rootClassName: null };
AgentRegistration.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default AgentRegistration;
